import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import stylesGeneric from "../../styles/generics.module.scss";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export const SaveButton = (props: {onClick: (() => void)}) => {
  return <button className={stylesGeneric['generic-button-wrapper']} onClick={props.onClick}>
    <FontAwesomeIcon className={stylesGeneric['generic-button']} icon={faFloppyDisk} />
  </button>
}
